import { CtaSection } from "./Components/ctaSection";
import { DemoVideoSection } from "./Components/demoVideo";
import { Footer } from "./Components/footer";
import { HeroSection } from "./Components/heroSection";
import { HowItWorksSection } from "./Components/howItWorks";
import { RoleCardsSection } from "./Components/roleCards";
import { TestimonialsSection } from "./Components/testimonialSection";
import { VerificationSection } from "./Components/verificationSection";
import { useUserInfo } from "GlobalStates/User";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { refreshAccessToken } from "Features/Auth/apis/refreshAccessToken";
import { ROUTES } from "Constants/AllRoutes";

export const LandingPageV2 = () => {
  const { setUser } = useUserInfo();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isComponentReady, setIsComponentReady] = useState(false);
  const [isQueryEnabled, setIsQueryEnabled] = useState(false);

  const { data, isLoading, error } = useQuery({
    queryKey: ["userLogin"],
    queryFn: refreshAccessToken,
    enabled: isQueryEnabled,
  });

  useEffect(() => {
    setIsComponentReady(true);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (isComponentReady) {
        setIsQueryEnabled(Boolean(!state?.justLoggedOut));
      }
    }, 3000);
  }, [isComponentReady, state]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      setUser({
        token: data?.data?.accessToken,
        name: data?.data?.name,
        role: data?.data?.role,
        hasCompletedProfile: data?.data?.hasCompletedProfile,
        isVerified: data?.data?.isVerified,
        picture: data?.data?.picture,
      });
      if (data?.data?.hasCompletedProfile) {
        navigate(ROUTES.MY_CALENDAR);
      } else {
        navigate(ROUTES.REGISTER_ROLE);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, error]);
  return (
    <main className="h-full w-full">
      <HeroSection />
      <DemoVideoSection />
      {/* <SocialProofSection /> */}
      <RoleCardsSection />
      <HowItWorksSection />
      <VerificationSection />
      {/* <FeaturesSection /> */}
      <TestimonialsSection />
      <CtaSection />
      <Footer />
    </main>
  );
};
